import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ComponentType } from 'react';

import { AwardingDataGridRow, AwardingDataGridRowType } from '../../components/AwardingDataGrid/AwardingDataGrid.types';
import { ActionCell } from '../ActionCell/ActionCell';
import { DiscountCell } from '../DiscountCell/DiscountCell';
import { LineItemCell } from '../LineItemCell/LineItemCell';
import { ProcessedByCell } from '../ProcessedByCell/ProcessedByCell';
import { PurchaseOrderCell } from '../PurchaseOrderCell/PurchaseOrderCell';
import { SupplierMetricsCell } from '../SupplierMetricsCell/SupplierMetricsCell';
import {
  CurrencyCell,
  DateRangeCell,
  EmptyFallbackCell,
  NegotiationProcessStatusChipCell,
  NegotiationStatusChipCell,
  SupplierLinkCell,
} from '~/components/DataGridCustom';

const typeMap: { [key in AwardingDataGridRowType]?: ComponentType<any> | undefined } = {
  [AwardingDataGridRowType.PROCESS_STATUS]: NegotiationProcessStatusChipCell,
  [AwardingDataGridRowType.STATUS]: NegotiationStatusChipCell,
  [AwardingDataGridRowType.SUPPLIER_REFERENCE]: EmptyFallbackCell,
  [AwardingDataGridRowType.DELIVERY_TIME_FRAME]: DateRangeCell,
  [AwardingDataGridRowType.INITIAL_TOTAL]: CurrencyCell,
  [AwardingDataGridRowType.FINAL_TOTAL]: CurrencyCell,
  [AwardingDataGridRowType.FINAL_TOTAL_WITH_TAXES]: CurrencyCell,
  [AwardingDataGridRowType.TOTAL_SPEND_PAST_YEAR]: SupplierMetricsCell,
  [AwardingDataGridRowType.ORDERS_PAST_YEAR]: SupplierMetricsCell,
  [AwardingDataGridRowType.DISCOUNT]: DiscountCell,
  [AwardingDataGridRowType.PROCESSED_BY]: ProcessedByCell,
  [AwardingDataGridRowType.ACTION]: ActionCell,
  [AwardingDataGridRowType.LINE_ITEM]: LineItemCell,
  [AwardingDataGridRowType.SUPPLIER]: SupplierLinkCell,
  [AwardingDataGridRowType.PURCHASE_ORDERS]: PurchaseOrderCell,
};

export const TypeSwitchCell = (props: GridRenderCellParams<any, AwardingDataGridRow>) => {
  const { row, value } = props;

  const { type } = row;

  const CellComponent = typeMap[type as AwardingDataGridRowType];
  if (CellComponent) {
    return <CellComponent row={row} {...value} />;
  }
  return null;
};
